import { GoogleButton } from '@/components/base/social-buttons/google-button';
import { type ReactNode } from 'react';

export function SocialLoginButtons({
  children,
  googleButtonText,
}: {
  children?: ReactNode;
  googleButtonText?: string;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex w-full flex-col items-stretch justify-center gap-6">
        <GoogleButton>{googleButtonText}</GoogleButton>
      </div>
      {children}
    </div>
  );
}
